/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */

import { DayOffWeek } from '../interfaces';

/* eslint-disable no-undef */
export function CreateFunction(daysOfWeek: Array<DayOffWeek>) {
  const turnos: Array<any> = [];

  // SEG
  // @ts-ignore
  daysOfWeek[0].hours.map((item: Hour) => {
    if (item.idTurno === 1) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 1,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 1,
      });
    }
    if (item.idTurno === 2) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 2,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 1,
      });
    }
    if (item.idTurno === 3) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 3,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 1,
      });
    }
  });
  // TER
  // @ts-ignore
  daysOfWeek[1].hours.map((item: Hour) => {
    if (item.idTurno === 1) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 1,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 2,
      });
    }
    if (item.idTurno === 2) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 2,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 2,
      });
    }
    if (item.idTurno === 3) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 3,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 2,
      });
    }
  });
  // QUART
  // @ts-ignore
  daysOfWeek[2].hours.map((item: Hour) => {
    if (item.idTurno === 1) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 1,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 3,
      });
    }
    if (item.idTurno === 2) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 2,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 3,
      });
    }
    if (item.idTurno === 3) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 3,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 3,
      });
    }
  });
  // QUINT
  // @ts-ignore
  daysOfWeek[3].hours.map((item: Hour) => {
    if (item.idTurno === 1) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 1,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 4,
      });
    }
    if (item.idTurno === 2) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 2,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 4,
      });
    }
    if (item.idTurno === 3) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 3,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 4,
      });
    }
  });

  // SEXT
  // @ts-ignore
  daysOfWeek[4].hours.map((item: Hour) => {
    if (item.idTurno === 1) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 1,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 5,
      });
    }
    if (item.idTurno === 2) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 2,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 5,
      });
    }
    if (item.idTurno === 3) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 3,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 5,
      });
    }
  });

  // SAB
  // @ts-ignore
  daysOfWeek[5].hours.map((item: Hour) => {
    if (item.idTurno === 1) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 1,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 6,
      });
    }
    if (item.idTurno === 2) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 2,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 6,
      });
    }
    if (item.idTurno === 3) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 3,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 6,
      });
    }
  });

  // DOM
  // @ts-ignore
  daysOfWeek[6].hours.map((item: Hour) => {
    if (item.idTurno === 1) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 1,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 0,
      });
    }
    if (item.idTurno === 2) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 2,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 0,
      });
    }
    if (item.idTurno === 3) {
      if (!item.init || !item.end) {
        return;
      }
      turnos.push({
        codigoTipoTurno: 3,
        horaInicio: String(new Date(item.init).toLocaleTimeString()),
        horaFim: String(new Date(item.end).toLocaleTimeString()),
        quantidadePosicoes: item.quantidadePosicoes,
        idDiaSemana: 0,
      });
    }
  });
  return turnos;
}
